import React from 'react';
import styled from 'styled-components';

import { Product, getProductImageSrc, WishlistHelper } from '@packages/common';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

import {
  HAS_PSUDO_SKELETON_LIGHT,
  PSUDO_SKELETON_NO_PADDING,
  PSUDO_SKELETON_ABSOLUTE,
  PSUDO_FULL_WIDTH,
} from '@packages/ui';
import { ProductTileImage } from './ProductTileImage';
import { ProductTileWidgets } from './ProductTileWidgets';

const PRODUCT_IMAGES_PATH = getPublicRuntimeConfig('PRODUCT_IMAGES_PATH');

export interface ProductTileTopProps {
  product: Product;
  wishlistHelper: WishlistHelper;
  showPartnerName?: boolean;
  hidePromotionsOnXS: boolean;
  isSlider?: boolean;
  sorted: boolean;
  index: number;
}

const ImageWrapper = styled.div<{ isSlider: boolean }>`
  overflow: hidden;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
`;

const pseudoSkeletonClassNameForChildren = `${HAS_PSUDO_SKELETON_LIGHT} ${PSUDO_SKELETON_NO_PADDING} ${PSUDO_SKELETON_ABSOLUTE} ${PSUDO_FULL_WIDTH}`;

export const ProductTileTop: React.FC<ProductTileTopProps> = ({
  product,
  wishlistHelper,
  isSlider,
  hidePromotionsOnXS,
  sorted,
  index,
}) => {
  // TODO: This ugly hardcoded style is here because of SSR problems
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '0',
        paddingTop: '75%',
      }}
    >
      <ImageWrapper isSlider={!!isSlider} className={pseudoSkeletonClassNameForChildren}>
        <ProductTileImage imageData={getProductImageSrc(PRODUCT_IMAGES_PATH, product)}></ProductTileImage>
      </ImageWrapper>
      <ProductTileWidgets
        hidePromotionsOnXS={hidePromotionsOnXS}
        className={pseudoSkeletonClassNameForChildren}
        wishlistHelper={wishlistHelper}
        product={product}
        sorted={sorted}
        index={index}
      />
    </div>
  );
};

ProductTileTop.displayName = 'ProductTileTop';
